<template>

    <Dialog :dialog="dlg" :loading="dlg.loading">
        <template v-slot:content>
            <v-form ref="form">
                <v-card flat>
                    <v-card-text class="pt-2">
                        <FormRow label="Relatie">    
                            <RelationCombo :model='dlg' :rules='dlg.ruleMandatory' v-model='dlg.id_relation'></RelationCombo>
                        </FormRow>
                        <FormRow label="Standaard activiteit">
                            <ActivityTypeCombo project :model="dlg" v-model="dlg.id_type"></ActivityTypeCombo>
                        </FormRow>
                    </v-card-text>
                </v-card>

            </v-form>
        </template>

    </Dialog>

</template>

<script setup>

    import Dialog from '@shared/ui/dialogs/ModelDialog'
    import clsDialogModel from '@cls/clsDialogModel'
    import FormRow from '@controls/forms/FormRow'
    import { computed, ref } from 'vue'
    import TextField from '@controls/input/TextField'
    import {partner as api} from '@app/api'
    import {partner as list} from '@app/list'
    import RelationCombo from '@controls/combo/Relation'
    import ActivityTypeCombo from '@controls/combo/ActivityType'

    let form=ref(null)

    /**
     * For an alert dialog, we do not need a model. Just use the dialog.
     */
    class DialogModelPartner extends clsDialogModel {
        id_relation = null;
        id_type = null; 

        get fillable() { return ['id_relation', 'id_type']; }

        // load does just fill the model with default value - empty. No server interaction.
        async load(params) {
            var result = await api.gload(params.id);
            return result.data;
        }

        // commit in our case just returns the data to the caller. No server interaction.
        // data already contains the toJSON()'d data members
        async save(data) {
            var result = await api.save(data);            
            await list.reload(); // reload the list of activity types, so that the new one is available in the combo
            this.fill(result.data);
        }
    }

    let dlg = ref (new DialogModelPartner( { 
        modelName: "partner",         
        dlgTitle: "Partner",
        forms: form, 
        icon: 'relation', 
        saveText: 'Ga door',        
        useDirtyCheck: true,
        keepOpen: false,
    }));
    
</script>